export default __webpack_public_path__ + "static/7-30b60a70449dddfd64aa88f3649941dc.webp";